import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientRequestComponent } from './client-request/client-request.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { ClientMasterComponent } from './client-master.component';

const routes: Routes = [{
  path: '',
  component: ClientMasterComponent,
  children:[
    { path:"",component: ClientListComponent},
    { path: 'users',component: ClientListComponent},
    { path: 'request',component: ClientRequestComponent},
    { path: 'request/:uuid',component: ClientRequestComponent},
    { path: 'details/:uuid',component: ClientDetailsComponent},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientMasterRoutingModule { }
